/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ResourceActions } from '@common/tech-shared';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { HintActions } from './+state/hint.actions';
import { HintSelectors } from './+state/hint.selectors';

@Injectable()
export class HintService {
  private readonly store = inject(Store);

  actions: ResourceActions;

  public refresh(): void {
    this.store.dispatch(HintActions.refreshHintList());
  }

  public hasUserNoOrganisationsEinheitIdHint(): Observable<boolean> {
    return this.store.select(HintSelectors.hasUserNoOrganisationsEinheitIdHint);
  }

  public hasNewRequestedDatenfreigabe(): Observable<boolean> {
    return this.store.select(HintSelectors.hasNewRequestedDatenfreigabe);
  }
}
